import * as React from "react";
const SvgFloppy = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M21.5556 6H8.22222C6.98889 6 6 7 6 8.22222V23.7778C6 25 6.98889 26 8.22222 26H23.7778C25 26 26 25 26 23.7778V10.4444L21.5556 6ZM23.7778 23.7778H8.22222V8.22222H20.6333L23.7778 11.3667V23.7778ZM16 16C14.1556 16 12.6667 17.4889 12.6667 19.3333C12.6667 21.1778 14.1556 22.6667 16 22.6667C17.8444 22.6667 19.3333 21.1778 19.3333 19.3333C19.3333 17.4889 17.8444 16 16 16ZM9.33333 9.33333H19.3333V13.7778H9.33333V9.33333Z",
	fill: "black"
}));
export default SvgFloppy;
